import { render } from "./SelectArrowIcon.vue?vue&type=template&id=4522e6a4&bindings={}"
import script from "./SelectArrowIcon.vue?vue&type=script&lang=ts"
export * from "./SelectArrowIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script